import { checkIsAbortError } from "./chunk-72S2U22Q.mjs";
import { __export } from "./chunk-QK4PKNB3.mjs"; // src/utils/Sentry.ts

var Sentry_exports = {};

__export(Sentry_exports, {
  addGlobalEventProcessor: function addGlobalEventProcessor() {
    return _addGlobalEventProcessor;
  }
});

var _addGlobalEventProcessor = function _addGlobalEventProcessor(event, hint) {
  var originalException = hint === null || hint === void 0 ? void 0 : hint.originalException;
  var isAbortError = checkIsAbortError(originalException);

  if (isAbortError) {
    return null;
  }

  return event;
};

export { _addGlobalEventProcessor as addGlobalEventProcessor, Sentry_exports };